module.exports = __webpack_public_path__ + "img/plan3_s.68182b68.svg";